export default "__VITE_ASSET__4455c49e__"